import { render, staticRenderFns } from "./CardTipoAgentes.vue?vue&type=template&id=2576a92e&scoped=true"
import script from "./CardTipoAgentes.vue?vue&type=script&lang=js"
export * from "./CardTipoAgentes.vue?vue&type=script&lang=js"
import style0 from "./CardTipoAgentes.vue?vue&type=style&index=0&id=2576a92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576a92e",
  null
  
)

export default component.exports